<template>
    <v-layout class="justify-space-between">
        <v-flex sm12 md11 lg9
                xl7
        >
            <v-data-table
                :total-items="total"
                :pagination.sync="table.content.pagination"
                :items="table.content.body"
                sort-icon="keyboard_arrow_down"
                class="rating-block__table"
                hide-actions
            >
                <template slot-scope="props" slot="headers">
                    <tr v-if="table.content.body.length && table.content.body[0].item.hasOwnProperty('chevron')" class="white shadowed">
                        <td v-if="entity && entity.item" class="py-4 red-text pl-4">{{ name_place(entity.position, entity.item.name) }}</td>
                        <td v-else class="py-4 red-text pl-4">{{ name_place(relative_id, ` ${user.name}  ${user.patronymic} ${user.family}`) }}</td>
                        <td class="py-2 rating-block__table-chevron">
                            <v-layout align-center>
                                <img v-if="user.achievments.image" :src="user.achievments.image" alt="chevron"
                                     width="30px"
                                     height="25px" class="mr-1"
                                >
                                <div v-if="user.achievments.name" class="pb-1">
                                    {{ $vuetify.breakpoint.xs ? '' : $t(user.achievments.name) }}
                                </div>
                                <div v-else class="pb-1">-</div>
                            </v-layout>
                        </td>
                        <td class="py-3 red-text">{{ entity && entity.rating ? entity.rating : '-' }}</td>
                        <td :class="{
                                'green-text':user_rating.progress && parseInt(user_rating.progress) > 0,
                                'red-text':user_rating.progress && user_rating.progress < 0
                            }"
                            class="py-3 pr-4"
                        >{{ parseInt(entity && entity.progress ? entity.progress: 0) > 0 ? '+' : '' }}{{ entity && entity.progress ? entity.progress : '-' }}</td>
                    </tr>
                    <tr v-else class="white shadowed">
                        <td class="py-4 red-text pl-4" v-html="name_place(get_company_rating.place, company_name || company_info.name)"></td>
                        <td class="py-2 red-text">{{ get_company_rating.level ? get_company_rating.level : '-' }}</td>
                        <td class="py-3 red-text">{{ get_company_rating.rating ? get_company_rating.rating : 0 }}</td>
                        <td :class="{
                                'green-text':get_company_rating.progress && parseInt(get_company_rating.progress) > 0,
                                'red-text':get_company_rating.progress && get_company_rating.progress < 0
                            }"
                            class="py-3 pr-4"
                        >{{ parseInt(get_company_rating.progress) > 0 ? '+' : '' }}{{ get_company_rating.progress }}</td>
                    </tr>
                </template>
                <template slot-scope="props" slot="items">
                    <tr>
                        <template v-if="props.item.item.hasOwnProperty('chevron')">
                            <td class="py-2 pl-4" :class="{'grey-text': props.item.place > 3}">
                                <router-link class="link--anchor" :to="{name: 'profile_other', params: {id: props.item.item.id}}">
                                    {{ name_place(props.item.place, props.item.item.name) }}
                                </router-link>
                            </td>
                            <td class="py-2">
                                <v-layout align-center>
                                    <img v-if="props.item.item.chevron" :src="props.item.item.chevron" alt="chevron"
                                         width="30px"
                                         height="25px" class="mr-1"
                                    >
                                    <div v-if="props.item.item.rank" class="pb-1">{{
                                        $vuetify.breakpoint.xs ? '' : $t(props.item.item.rank)
                                    }}
                                    </div>
                                    <div v-else class="pb-1">-</div>
                                </v-layout>
                            </td>
                            <td class="py-2" :class="{'grey-text': props.item.place > 3}">{{ props.item.item.rating }}</td>
                            <td :class="{
                                    'green-text': props.item.progress && parseInt(props.item.progress) > 0,
                                    'red-text': props.item.progress && String(props.item.progress).includes('-')
                                }"
                                class="py-2 pr-4"
                            > {{ parseInt(props.item.progress) > 0 ? '+' : '' }}{{ props.item.progress }}
                            </td>
                        </template>
                        <template v-else>
                            <td class="py-2 pl-4" :class="{'grey-text': props.item.place > 3}">{{
                                name_place(props.item.place, props.item.item.name)
                            }}
                            </td>
                            <td class="py-2" :class="{'grey-text': props.item.place > 3}">{{ props.item.item.level }}</td>
                            <td class="py-2" :class="{'grey-text': props.item.place > 3}">{{ props.item.item.rating }}</td>
                            <td :class="{
                                    'green-text':props.item.progress && parseInt(props.item.progress) > 0,
                                    'red-text':props.item.progress && String(props.item.progress).includes('-')
                                }"
                                class="py-2 pr-4"
                            > {{ parseInt(props.item.progress) > 0 ? '+' : '' }}{{ props.item.progress }}
                            </td>
                        </template>
                    </tr>
                </template>
                <div slot="no-data" :value="true" color="error"
                     icon="warning" class="body-2"
                >
                    {{ loading ? $t('Нет данных') : $t('Загрузка') }}...
                </div>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapState, mapGetters} from 'vuex';


export default {
  name : 'RatingTable',
  props: {
    table: {
      type    : Object,
      required: true,
    },
    total: {
      default: undefined,
    },
    loading: {
      type   : Boolean,
      default: true,
    },
    entity: {
      type: Object,
    },
  },
  data() {
    return {
      company_name: '',
    };
  },
  mounted() {
    if (JSON.parse(localStorage.getItem('user')).company_id) {
      this.company_name = JSON.parse(localStorage.getItem('user')).company_name;
    } else {
      this.company_name = ' ';
    }
  },
  methods: {
    name_place(place, name) {
      if (!place || place == -1) {
        return '- ' + name;
      } else {
        let text_place = place ? place + '. ' : '- ';
        return text_place + name;
      }
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapState('rating', [
      'user_in_company_rating',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('company_profile/info', [
      'company_info',
    ]),
    ...mapGetters('rating', [
      'rating',
      'user_rating',
      'company_rating',
      'user_in_company_rating',
    ]),
    get_company_rating() {
      let obj;

      if (this.company_rating.position) {
        obj = {
          place   : this.company_rating.position,
          rating  : this.company_rating.rating,
          progress: this.company_rating.progress,
          level   : this.company_rating.level,
        };
      } else {
        obj = {
          place : 0,
          rating: 0,
          level : this.company_rating.level,
        };
      }

      return obj;
    },
    relative_id() {
      let id = this.user.id;
      let value = this.rating.find((value) => parseInt(value.item.id) === id) || {place: false};
      return (!!value.place) ? value.place : false;
    },
    rating() {
      return this.table.content.body;
    },
  },
};
</script>

